'use strict'

import ClientsQueue from '@/app/model/clients/clients-queue'
import Helper from '@/utils/helper'

class ClientsQueueConverter {
  /**
   * @param {Clients} model
   * @return ClientsQueue
   */
  static convert (model) {
    const items = [{ title: model.getClientsTitle(), tickets: model.getClients() }]

    if (Helper.isDefined(model.getClients2()) || Helper.isDefined(model.getClientsTitle2())) {
      items.push({ title: model.getClientsTitle2(), tickets: model.getClients2() })
    }

    return new ClientsQueue({ items })
  }
}

export default ClientsQueueConverter
